export const devError = (...args) => {
  if (process.env.NODE_ENV === "development") console.error(...args);
};
